import { createStore, combineReducers } from 'redux';

// Define initial state
const initialState = {
  task: '',
  reportType: 'research_report',
  expandedTask: '',
  editableExpandedTask: '',
  // Add other initial state properties as needed
};

// Define reducer for Walter state
function walterReducer(state = initialState, action) {
  switch (action.type) {
    case 'SET_TASK':
      return {
        ...state,
        task: action.payload,
      };
    case 'SET_REPORT_TYPE':
      return {
        ...state,
        reportType: action.payload,
      };
    // Add other case statements for different actions
    default:
      return state;
  }
}

// Combine reducers if you have more than one
const rootReducer = combineReducers({
  walter: walterReducer,
  // Add other reducers here
});

// Create Redux store
const store = createStore(rootReducer);

export default store;
